import { render, staticRenderFns } from "./privateSchool.vue?vue&type=template&id=2b511ea7&scoped=true&"
import script from "./privateSchool.vue?vue&type=script&lang=js&"
export * from "./privateSchool.vue?vue&type=script&lang=js&"
import style0 from "./privateSchool.vue?vue&type=style&index=0&id=2b511ea7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b511ea7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCol,VContainer,VRow,VSelect})
